module.exports = __webpack_public_path__ + "static/img/complaint_detail_2.228e8c1a.svg";